class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();

    // Check if a stored discount exists and set the input value
    if (localStorage.getItem('storedDiscount')) {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }

    // Attach event listener directly to the input field
    const discountInput = this.querySelector('input[name="discount"]');
    if (discountInput) {
      discountInput.addEventListener('keydown', (event) => {
        // Trigger logic only if Enter key is pressed
        if (event.key === 'Enter') {
          event.preventDefault(); // Prevent any default action (e.g., form submission)

          // Get the coupon code value
          this.val = discountInput.value;

          // Store the value in localStorage
          localStorage.setItem('storedDiscount', this.val);

          // Send the discount code to the server
          fetch(`/discount/${this.val}`)
            .then((response) => response.text())
            .then((responseText) => {
              // Optionally handle server response
              console.log(responseText);
            })
            .catch((error) => {
              console.error('Error:', error);
            });

          // Hide the popup and deactivate preview cart
          document.querySelector('.popup-toolDown.show').classList.remove('show');
          document.querySelector('.previewCart').classList.remove('active-tool');
        }
      });
    }
  }
}

customElements.define('coupon-code', CouponCode);